import React from 'react'
import { NextWrapper } from 'data-fetching-wrapper'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, PaginaNode } from '@gql/graphql'
import LandingNewsletterTemplate from '@components/templates/LandingNewsletterTemplate/LandingNewsletterTemplate'

interface Props {
  pagina?: PaginaNode
}

const RegistrazioneNewsletter = ({ pagina }: Props) => <LandingNewsletterTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'registrazione-newsletter', preview },
      context: {
        headers,
      },
    })
    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina },
      revalidate: 60 * 20,
    }
  },
  '/registrazione-newsletter'
)

export default RegistrazioneNewsletter
